import clsx from "clsx";
import { FunctionComponent } from "react";

import Button from "@ui/components/cta/Button";

import * as styles from "./NotificationsFilters.css";

interface NotificationsFiltersProps {
  filter: "all" | "unread";
  onFilterClick: (filter: "all" | "unread") => void;
  /**
   * `track` renders the FeedTabs-style sliding pill switcher used inside the
   * Verge notifications drawer / page. `default` keeps the standalone outlined
   * pill buttons used elsewhere (e.g., the SBNation popover).
   */
  variant?: "default" | "track";
}

const FILTERS: Array<{ key: "all" | "unread"; label: string }> = [
  { key: "all", label: "All" },
  { key: "unread", label: "Unread" },
];

const NotificationsFilters: FunctionComponent<NotificationsFiltersProps> = ({
  filter,
  onFilterClick,
  variant = "default",
}) => {
  if (variant === "track") {
    return (
      <div className={styles.trackContainer}>
        <div className={styles.trackInner} role="tablist">
          {FILTERS.map(({ key, label }, index) => (
            <button
              key={key}
              role="tab"
              type="button"
              aria-selected={filter === key}
              onClick={() => onFilterClick(key)}
              className={clsx(
                styles.trackTab,
                index > 0 && styles.trackTabSubsequent,
                filter === key && styles.trackTabActive,
              )}
            >
              {label}
            </button>
          ))}
          <div className={styles.trackFiller} aria-hidden />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.filters}>
      {FILTERS.map(({ key, label }) => (
        <Button
          key={key}
          className={clsx(
            styles.filterButton,
            filter === key && styles.filterButtonActive,
          )}
          text={label}
          displayType="cyclone"
          onClick={() => void onFilterClick(key)}
          active={filter === key}
          tabIndex={0}
        />
      ))}
    </div>
  );
};

export default NotificationsFilters;
